import { WithStyles, withStyles } from '@mui/styles';

import OpsAdminDashboard from './opsAdminDashboard';
import { muiStyles } from './styles';

export interface OpsAdminDashboardProps extends WithStyles<typeof muiStyles> {
    setAssetListOverlayOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}

export default withStyles(muiStyles)(OpsAdminDashboard);